import React from 'react';
import { Map, Layers, ShoppingBag, Menu } from 'lucide-react';

export type MobileTab = 'map' | 'fields' | 'cart' | 'menu';

export interface MobileBottomNavProps {
  activeTab: MobileTab;
  onTabChange: (tab: MobileTab) => void;
  fieldsCount: number;
  cartCount: number;
  onOpenMenu: () => void;
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  activeTab,
  onTabChange,
  fieldsCount,
  cartCount,
  onOpenMenu,
}) => {
  return (
    <nav className="mobile-bottom-nav" aria-label="Mobil bundmenu">
      <button
        type="button"
        data-guide="mobile-nav-map"
        className={`mobile-nav-btn ${activeTab === 'map' ? 'active' : ''}`}
        onClick={() => onTabChange('map')}
        aria-label="Kort"
        title="Kort"
      >
        <div className="mobile-nav-icon-wrap">
          <Map size={21} />
        </div>
        <span>Kort</span>
      </button>

      <button
        type="button"
        data-guide="mobile-nav-fields"
        className={`mobile-nav-btn ${activeTab === 'fields' ? 'active' : ''}`}
        onClick={() => onTabChange('fields')}
        title="Marker"
      >
        <div className="mobile-nav-icon-wrap">
          <Layers size={21} />
          {fieldsCount > 0 && <span className="mobile-nav-badge">{fieldsCount}</span>}
        </div>
        <span>Marker</span>
      </button>

      <button
        type="button"
        data-guide="mobile-nav-cart"
        className={`mobile-nav-btn ${activeTab === 'cart' ? 'active' : ''}`}
        onClick={() => onTabChange('cart')}
        title="Indkøbskurv"
      >
        <div className="mobile-nav-icon-wrap">
          <ShoppingBag size={21} />
          {cartCount > 0 && <span className="mobile-nav-badge">{cartCount}</span>}
        </div>
        <span>Kurv</span>
      </button>

      <button
        type="button"
        data-guide="mobile-nav-menu"
        className="mobile-nav-btn"
        onClick={onOpenMenu}
        aria-label="Menu"
        title="Flere sider"
      >
        <div className="mobile-nav-icon-wrap">
          <Menu size={21} />
        </div>
        <span>Menu</span>
      </button>
    </nav>
  );
};
